/**
 * ColorsCard — Primär- und Akzentfarbe + Vorschau.
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Palette } from 'lucide-react';

export const ColorsCard = ({ formData, onChange }) => (
  <Card className="border-border/60">
    <CardHeader>
      <CardTitle className="font-heading flex items-center gap-2">
        <Palette className="h-5 w-5 text-primary" />
        Farbschema
      </CardTitle>
      <CardDescription>Passen Sie die Farben an Ihr Corporate Design an</CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="primary_color">Primärfarbe</Label>
          <div className="flex gap-2">
            <Input
              id="primary_color"
              type="color"
              value={formData.primary_color}
              onChange={(e) => onChange('primary_color', e.target.value)}
              className="w-16 h-10 p-1 cursor-pointer"
              data-testid="primary-color-input"
            />
            <Input
              value={formData.primary_color}
              onChange={(e) => onChange('primary_color', e.target.value)}
              placeholder="#14532D"
              className="flex-1"
            />
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="secondary_color">Akzentfarbe</Label>
          <div className="flex gap-2">
            <Input
              id="secondary_color"
              type="color"
              value={formData.secondary_color}
              onChange={(e) => onChange('secondary_color', e.target.value)}
              className="w-16 h-10 p-1 cursor-pointer"
              data-testid="secondary-color-input"
            />
            <Input
              value={formData.secondary_color}
              onChange={(e) => onChange('secondary_color', e.target.value)}
              placeholder="#65A30D"
              className="flex-1"
            />
          </div>
        </div>
      </div>
      <div className="p-4 bg-secondary/30 rounded-lg">
        <p className="text-sm text-muted-foreground mb-2">Vorschau:</p>
        <div className="flex gap-2">
          <Button type="button" style={{ backgroundColor: formData.primary_color }} className="rounded-full">
            Primär
          </Button>
          <Button type="button" style={{ backgroundColor: formData.secondary_color }} className="rounded-full">
            Akzent
          </Button>
        </div>
      </div>
    </CardContent>
  </Card>
);
